import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

const Divider = styled.div`
  padding: 20px 20px 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${colors.darkGrey};
  border-top: 1px solid ${colors.mediumBlueGrey};
`;

export default Divider;
